import { logAmplitudeEvent } from 'src/utils/analytics';
import { MARKET_HOME_CHAT_PATH, RoutesMap } from 'src/utils/const';

import { detectUserIntent } from './intentDetection';

const AUTH_ONLY_PATH_PREFIXES = [
  RoutesMap.Register,
  RoutesMap.Login,
  RoutesMap.ResetPassword,
];

function normalizePath(path: string): string {
  if (!path.startsWith('/')) {
    return `/${path}`;
  }
  return path;
}

/**
 * Pathname to open after a **new** email or Google signup.
 * Preserves deep links when `detectUserIntent` captured a non-auth page; otherwise chat Home.
 */
export function resolvePostSignupPath(): string {
  const intent = detectUserIntent();
  const raw = (intent.context?.landingPage || '').trim();
  if (!raw) {
    return MARKET_HOME_CHAT_PATH;
  }
  const p = normalizePath(raw);
  if (AUTH_ONLY_PATH_PREFIXES.some(prefix => p === prefix || p.startsWith(`${prefix}/`))) {
    return MARKET_HOME_CHAT_PATH;
  }
  return p;
}

/** Resolve target path, log, then full-page navigation (no postGoogleAuthDataUpdate on signup). */
export function completePostSignupNavigation(): void {
  const path = resolvePostSignupPath();
  logAmplitudeEvent('post_signup_redirect', { path });
  window.location.href = `${window.location.origin}${path}`;
}
